import { useState } from 'react'

export default function ReviewsSlider({ reviews }) {
  const [index, setIndex] = useState(0)
  const review = reviews[index]

  const prev = () => setIndex((i) => (i === 0 ? reviews.length - 1 : i - 1))
  const next = () => setIndex((i) => (i === reviews.length - 1 ? 0 : i + 1))

  return (
    <section className="mil-p-90-90">
      <div className="row justify-content-center mil-reviews-slider-frame">
        <div className="col-lg-8">
          <div className="mil-reviews-slider mil-mb-30">
            <div className="mil-review mil-center">
              <div className="mil-review-top">
                <img src={review.avatar} alt="customer" className="mil-avatar" />
                <div className="mil-name">
                  <h4 className="mil-mb-5">{review.name}</h4>
                  <p className="mil-upper">{review.role}</p>
                </div>
              </div>
              <p>{review.text}</p>
            </div>
          </div>
        </div>

        <div className="mil-slider-nav">
          <div className="mil-reviews-prev" role="button" aria-label="Previous review" onClick={prev}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ transform: 'rotate(180deg)' }}
              className="feather feather-arrow-right"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
          <div className="mil-reviews-next" role="button" aria-label="Next review" onClick={next}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-arrow-right"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>

        <div className="swiper-reviews-pagination">
          {reviews.map((r, i) => (
            <span
              key={r.name + i}
              role="button"
              aria-label={`Go to review ${i + 1}`}
              onClick={() => setIndex(i)}
              className={`mil-dot${i === index ? ' mil-dot-active' : ''}`}
              style={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: '50%',
                margin: '0 4px',
                cursor: 'pointer',
                background: i === index ? 'currentColor' : 'rgba(0,0,0,.2)',
              }}
            ></span>
          ))}
        </div>
      </div>
    </section>
  )
}
